import { createSlice } from "@reduxjs/toolkit";
import { decryptToken } from "../utils/tokenSecure";

const initialState = {
  userInfo: { personalThread: false },
  tokenMetadata: {},
  stripe: {},
};

export const metaDataSlice = createSlice({
  name: "metaData",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state = {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.payload,
          token: decryptToken(),
        },
      };
      localStorage.setItem(
        "userInfo",
        JSON.stringify({
          ...state.userInfo,
          ...action.payload,
          token: decryptToken(),
        })
      );
      return state;
    },
    setTokenMetadata: (state, action) => {
      state = {
        ...state,
        tokenMetadata: { ...state.tokenMetadata, ...action.payload },
      };
      return state;
    },
    setStripeMetadata: (state, action) => {
      state = {
        ...state,
        stripe: { ...state.stripe, ...action.payload },
      };
      return state;
    },
    resetMetaData: (state) => {
      state = initialState;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, resetMetaData, setTokenMetadata, setStripeMetadata } =
  metaDataSlice.actions;

export default metaDataSlice.reducer;
